// ============================================================
// InstancesSection - the body of the Traits and the Talents sections:
// the chips, and the picker that "+ ADD" opens above them.
// ============================================================
import type { ReactNode } from 'react';
import type { Character } from '../../engine/character/types';
import CatalogPicker from './CatalogPicker';
import InstanceChips from './InstanceChips';
import type { InstanceKind } from './instanceKinds';
import styles from './Sheet.module.css';

interface Props {
  kind: InstanceKind;
  character: Character;
  onChange: (partial: Partial<Character>) => void;
  disabled: boolean;
  /** Whether the picker is open; the section's caption holds the button. */
  picking: boolean;
  onPicking: (open: boolean) => void;
  /** Anything else the section carries, under the chips. */
  children?: ReactNode;
}

/** The "+ ADD" at a section caption's right edge. */
export function AddButton({ kind, disabled, onClick }: { kind: InstanceKind; disabled: boolean; onClick: () => void }) {
  return (
    <button
      type="button"
      className={styles.addButton}
      data-testid={`${kind}-add`}
      disabled={disabled}
      onClick={onClick}
    >
      + ADD
    </button>
  );
}

export default function InstancesSection(props: Props) {
  const { kind, character, onChange, disabled, picking, onPicking, children } = props;
  return (
    <>
      {picking && !disabled && (
        <CatalogPicker kind={kind} character={character} onChange={onChange} onClose={() => onPicking(false)} />
      )}
      <InstanceChips kind={kind} character={character} onChange={onChange} disabled={disabled} />
      {children}
    </>
  );
}
